// src/Components/modules/Authorizations/HistorialAutorizacionDialog.js
import React, { useState, useEffect } from "react";
import PropTypes from "prop-types";
import { Modal, List, Avatar, Typography, Card, Divider, Space } from "antd";
import {
  FileTextOutlined,
  ClockCircleOutlined,
  CheckCircleOutlined,
  CloseCircleOutlined,
} from "@ant-design/icons";
import api from "../../../axiosConfig";
import { esActorSistema, descripcionHistorial } from "../../../utils/historialSistema";

const { Text } = Typography;

function HistorialAutorizacionDialog({ open, onClose, autorizacionId }) {
  const [historial, setHistorial] = useState([]);

  useEffect(() => {
    if (autorizacionId && open) {
      api
        .get(`/autorizaciones/historial/${autorizacionId}`)
        .then((response) => {
          setHistorial(response.data);
        })
        .catch((error) => {
          console.error("Error al obtener el historial:", error);
        });
    }
  }, [autorizacionId, open]);

  const getIconByAction = (action) => {
    switch (action) {
      case "Creación de Autorización":
        return <FileTextOutlined style={{ color: "#1976D2" }} />;
      case "Actualización de Autorización":
        return <CheckCircleOutlined style={{ color: "#4CAF50" }} />;
      case "Eliminación de Autorización":
        return <CloseCircleOutlined style={{ color: "#F44336" }} />;
      default:
        return <ClockCircleOutlined style={{ color: "#FFC107" }} />;
    }
  };

  return (
    <Modal
      open={open}
      onCancel={onClose}
      title={
        <Text strong style={{ color: "#2E3B4E" }}>
          Historial de la Autorización
        </Text>
      }
      footer={null}
      width={800}
      centered
      style={{ borderRadius: "15px" }}
    >
      <div style={{ backgroundColor: "#f9f9f9", padding: "20px" }}>
        <List
          itemLayout="vertical"
          dataSource={historial}
          renderItem={(registro, index) => (
            <div key={registro.id}>
              <Card
                style={{ borderRadius: "8px", backgroundColor: "#fff" }}
                variant="borderless"
              >
                <List.Item>
                  <Space align="start" size="large">
                    <Avatar style={{ backgroundColor: "#3F51B5" }}>
                      {esActorSistema(registro) ? "S" : (registro.usuario?.nombre?.charAt(0) || "U")}
                    </Avatar>
                    <div>
                      <Text
                        strong
                        style={{ color: "#2E3B4E", fontSize: "16px" }}
                      >
                        {`${
                          esActorSistema(registro) ? "Sistema" : (registro.usuario?.nombre || "Usuario Desconocido")
                        } - ${registro.accion}`}
                      </Text>
                      <Text
                        style={{
                          display: "block",
                          marginTop: "8px",
                          marginBottom: "8px",
                          whiteSpace: "pre-wrap",
                          overflowWrap: "anywhere",
                        }}
                      >
                        {descripcionHistorial(registro)}
                      </Text>
                      <Space>
                        {getIconByAction(registro.accion)}
                        <Text type="secondary">
                          {new Date(registro.fecha).toLocaleString()}
                        </Text>
                      </Space>
                    </div>
                  </Space>
                </List.Item>
              </Card>
              {index < historial.length - 1 && <Divider />}
            </div>
          )}
        />
      </div>
    </Modal>
  );
}

HistorialAutorizacionDialog.propTypes = {
  open: PropTypes.bool.isRequired,
  onClose: PropTypes.func.isRequired,
  autorizacionId: PropTypes.oneOfType([PropTypes.string, PropTypes.number])
    .isRequired,
};

export default HistorialAutorizacionDialog;
